import type { Schemas } from "shared/schema";
import { useEffect } from "react";
import { MINUTE, QueryStore } from "shelving";
import { useReduce, useStore } from "shelving/react";
import { DB, MEMORY } from "../util/db.js";

const REFRESH_INTERVAL = MINUTE;

/** Shows a badge with the number of new notifcations, e.g. `1 */
export function NotificationDot({ uid, since, mods = "" }: { uid: string; since: number; mods?: string | undefined }): React.ReactElement | null {
	const noticeStore = useStore(useReduce(reduceNotificationStore, uid, since));
	useEffect(() => {
		const x = setInterval(() => {
			// Refresh on interval if window is in foreground and we're not already showing a dot.
			// If `since` has chanded this entire
			if (!document.hidden && noticeStore.count <= 0) noticeStore.refresh();
		}, REFRESH_INTERVAL);
		return () => clearInterval(x);
	}, [noticeStore]);
	return !noticeStore.loading && noticeStore.count ? <span className={`dot dot-active ${mods}`} title="New notification!" /> : null;
}

function reduceNotificationStore(previous: QueryStore<Schemas, "notification"> | undefined, uid: string, since: number): QueryStore<Schemas, "notification"> {
	if (previous?.query["date>="] === since) return previous;
	return new QueryStore("notification", { uid, "date>=": since, "$order": "!date", "$limit": 1 }, DB, MEMORY);
}
